import { sb } from '../supabase';

// What a registered supplier has DONE on the platform, for the supplier file at
// /admin2/verification/:id (owner, 2026-10-11 — the file replaces the legacy
// /admin/suppliers/:id, and the team should see the supplier's work without
// leaving the new console).
//
// Offers: every one, including admin_only — a held quote is exactly the row
// staff must act on (same reasoning as consoleRequestDetail.js). The admin
// reads them through the admin branch of offers_select.
// Conversations: from admin_trader_conversations(), the same source as
// /admin2/conversations — the supplier's own threads, plus those of the catalog
// factory it claimed, which are addressed to the factory rather than to it.

export async function fetchSupplierOffers(supplierId) {
  const { data: offers, error } = await sb.from('offers')
    .select('id, request_id, price, currency, status, managed_visibility, visibility_reason, created_at')
    .eq('supplier_id', supplierId).order('created_at', { ascending: false }).limit(100);
  if (error) {
    // Security rule 4 on our own backend: a swallowed read reads as "no offers".
    console.error('[fetchSupplierOffers] failed:', error.message || error);
    return { rows: [], failed: true };
  }
  const ids = [...new Set((offers || []).map((o) => o.request_id).filter(Boolean))];
  const { data: reqs } = ids.length
    ? await sb.from('requests').select('id, request_ref, title_ar, title_en, status').in('id', ids)
    : { data: [] };
  const byId = Object.fromEntries((reqs || []).map((r) => [r.id, r]));
  return { rows: (offers || []).map((o) => ({ ...o, request: byId[o.request_id] || null })), failed: false };
}

export async function fetchSupplierConversations(supplierId, factoryId) {
  const { data, error } = await sb.rpc('admin_trader_conversations');
  if (error) {
    console.error('[fetchSupplierConversations] failed:', error.message || error);
    return { rows: [], failed: true };
  }
  return {
    rows: (data || []).filter((c) => (c.channel === 'supplier' && c.counterpart_id === supplierId)
      || (factoryId && c.channel === 'factory' && c.counterpart_id === factoryId)),
    failed: false,
  };
}
